module.exports = __webpack_public_path__ + "static/media/pattern2@3x.33b6aed4.png";